import React from 'react';
import PropTypes from 'prop-types';

import { Dropdown } from 'react-bootstrap-5';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faEllipsisV } from '@fortawesome/pro-solid-svg-icons';

const DropdownControl = React.forwardRef(({ disabled, icon, label, variant, ...props }, ref) => {
  if (!icon && !label) {
    icon = faEllipsisV;
  }

  if (icon && !React.isValidElement(icon)) {
    icon = <FontAwesomeIcon icon={icon} />;
  }

  return (
    <Dropdown.Toggle disabled={disabled} ref={ref} variant={variant || 'ghost'} {...props}>
      {icon}
      {label}
      {!!label && <FontAwesomeIcon icon={faCaretDown} />}
    </Dropdown.Toggle>
  );
});

export default DropdownControl;

DropdownControl.propTypes = {
  disabled: PropTypes.bool,
  icon: PropTypes.object,
  label: PropTypes.string,
  variant: PropTypes.string,
};
